<template>
<b-navbar class="fixed-top menu" id="menu-shadow" toggleable="md"  >
    <b-navbar-brand to="/home">
        <img class="logo-img" src="/static/images/logo_cliker.png" alt="Logo_cliker">
      </b-navbar-brand>

    <b-navbar-toggle class="nav-button" target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <hr v-if="isMobile()">
        <b-navbar-nav v-show="!menuDisplay()">
          <b-nav-item href="" to="/home" @click="linkBeneficios()" class="menu-text">Beneficios</b-nav-item>
        <!--<b-nav-item href="" to="/home" @click="linkPrecios()" class="menu-text">Precios</b-nav-item>-->
        <b-nav-item href="" to="/blog" class="menu-text" >Blog</b-nav-item>
          <b-nav-item v-b-toggle.MenuCat href="" to="/blog" class="menu-text" @click="linkCategory()" >Categorías</b-nav-item>
          <b-nav-item v-if="logged" v-b-toggle.ManagerMenu class="menu-text" >Manejadores</b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav v-show="menuDisplay()">
        <b-nav-item href="" to="/home" @click="linkBeneficios()" class="menu-text">Beneficios</b-nav-item>
        <!--<b-nav-item href="" to="/home" @click="linkPrecios()" class="menu-text">Precios</b-nav-item>-->
        <b-nav-item href="" to="/blog" class="menu-text" >Blog</b-nav-item>
        <b-nav-item v-if="logged" v-b-toggle.ManagerMenu class="menu-text" >Manejadores</b-nav-item>
        <!-- <b-nav-item-dropdown text="Recursos" class="menu-text">
          <b-dropdown-item href="#">Recurso 1</b-dropdown-item>
          <b-dropdown-item href="#">REcurso 2</b-dropdown-item>
          <b-dropdown-item href="#">Recurso 3</b-dropdown-item>
          <b-dropdown-item href="#">Recurso 4</b-dropdown-item>
        </b-nav-item-dropdown> -->
      </b-navbar-nav>
    </b-collapse>

    <b-navbar-nav id="demo" class="ml-auto">
      <b-button @click="linkContact()" size="sm" pill class="my-2 my-sm-0 btnDemo" type="submit">Solicitar demo</b-button>
    </b-navbar-nav>
    
</b-navbar>

</template>

<script>
import {mapState,mapActions} from "vuex";
export default {
  data() {
    return {
      show: true,
    }
  },
  computed: {
   ...mapState("menu",['principal']),
   ...mapState("auth",['logged'])
  },
  watch: {
    principal(newValue, oldValue) {
      this.show = newValue;
    }
  },
  methods: {
    ...mapActions("auth",['setLog']),
    scrollTop(){
      document.getElementById("intro").scrollTo(0);
    },
    linkCategory(){
      setTimeout(function(){
        window.location = "#seccion-categorias"; 
        },100);
    },
    linkPrecios(){
      setTimeout(function(){
        window.location = "#precio"; 
      },100);
    },
    linkBeneficios(){
      setTimeout(function(){
        window.location = "#beneficios"; 
      },100);
    },
    linkContact(){
      setTimeout(function(){
        if(this.menuDisplay){
          window.location = "#contacto"; 
        }else{
          window.location = "/home#contacto"; 
        }
        
      },100);
    },
    isMobile(){
      var check = false;
      //console.log(window.screen.width);
      if(window.screen.width < 769){
        return check=true;
      }
    },
    menuDisplay(){
      return this.show;
    }
  },
  mounted () {
    this.setLog(localStorage.getItem("logged"));

    window.onscroll = function(){
      var scroll = document.documentElement.scrollTop;
      var menu = document.getElementById("menu-shadow");

      if(scroll > 0){
        menu.classList.add("shadow-menu");
      }else{
        menu.classList.remove("shadow-menu");
        menu.style.transitionDuration = "0.3s";
      }
    }
  }
}
</script>


<style scoped>
  .menu{
    background:#ffffff !important; 
    padding: 1.5% 6% 1.5% 6%;
  }
  .shadow-menu{
    -webkit-box-shadow: 0 0 7px rgba(0, 0, 0, 0.1) !important;
    -moz-box-shadow: 0 0 7px rgba(0, 0, 0, 0.1) !important;
    box-shadow: -2px 0 12px 2px rgba(0, 0, 0, 0.2);
    transition-duration:0.3s ;
  }
  
  .logo-img {
    width: 80px;
    margin-top:-10px;
  }

  .navbar-nav{
    margin-right: auto;
    margin-left: auto;
    text-align: center;
  }

  .nav-button{
    border:0;
  }

 .navbar-toggler-icon{
   background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='rgba(255, 255, 255, 1)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>") !important;
}

  .menu-text {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 16px;
    line-height: 18px;
    letter-spacing: 0.2px;
    color:  #2DB9D1 !important;
    padding: 0px 20px 0px 20px;
    color: rgba(255, 255, 255, 1);
  }

  .navbar-light .navbar-nav .nav-link {
    color:  #2DB9D1 !important;
  }

  .btnDemo {
      font-family: Muli-Bold;
      font-style: normal;
      font-size: 14px;
      line-height: 18px;
      padding: 13px 27px;
      color: #FFF ;
      background: #2DB9D1;
      border-color: #2DB9D1 !important;
      border-radius: 18px;
  }

  .btnDemo:hover {
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }

  @media all and (max-width: 768px) {
    #demo{
      display: none;
    }
    
  }
</style>